const tinycolor = require('tinycolor2')
const { generate: generateAntDesignPalette } = require('@ant-design/colors')

export const zoom = () => {
  let dpi = ''
  let browserScale = ''
  let windowsScale = ''

  // 屏幕分辨率宽度（不受浏览器缩放影响，但受系统缩放影响）
  // 例如显示器物理分辨率为 3840, win10 设置系统缩放 150%, 则返回 2560
  const screenWidth = screen.width

  // 浏览器整体缩放（包含系统层面）
  if (window.devicePixelRatio !== undefined) {
    dpi = window.devicePixelRatio
    // eslint-disable-next-line no-undef
  } else if (~ua.indexOf('msie')) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      dpi = screen.deviceXDPI / screen.logicalXDPI
    }
  }

  // 单浏览器缩放
  if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    // browserScale = Number((window.outerWidth / window.innerWidth).toFixed(2));
    browserScale = window.outerWidth / window.innerWidth
  }

  // 计算得到纯系统层面（仅对 windows 系统生效）
  if (dpi && browserScale) {
    // windowsScale = Number((dpi / browserScale).toFixed(2));
    windowsScale = dpi / browserScale
  }

  return {
    dpi,
    browserScale,
    windowsScale,
    screenWidth
  }
}
/**
 * @description: 获得色阶css变量
 * @param {*} color 颜色
 * @param {*} colorName 颜色变量名
 * @param {*} count 色阶个数
 * @return {*} 返回色阶css变量 字符串
 */
export const getColorScaleCssVariable = (color, colorName, count = 10) => {
  // 将输入的颜色值转换为 hex 格式
  const hexColor = tinycolor(color).toHexString()
  // 使用 Ant Design 3.x 色板生成算法生成色板
  const antDesignPalette = generateAntDesignPalette(hexColor)
  // 取出色板中的前 count 个颜色
  const palette = antDesignPalette.slice(0, count)
  const result = palette
    .map((color, index) => `--color-${colorName}-${index}: ${color};`)
    .join('\n')
  return result
}
export const toggleCssLinks = (links, key) => {
  const l = links[key]
  if (!l) return
  // const el = document.querySelector(`[href='${l}']`);
  const el = document.querySelector('[title="CubeTheme"]')
  // console.log('el', el);

  // 如果已经有主题文件，更改 url；如果没有，则新建
  if (el) {
    el.setAttribute('href', l)
  } else {
    const link = document.createElement('link')
    link.href = l
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.title = 'CubeTheme'
    document.head.appendChild(link)
  }
}
